// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "build/js/" + chunkId + "." + {"594":"654cc1e4","959":"506fe6d8"}[chunkId] + ".js";
};